import type { HeadingProps } from '@components/text/types/props';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './text.module.scss';

const rootClass = validateString(styles.h6);
const responsiveClass = validateString(styles.responsive);

function H6({
  children,
  className,
  responsive = true,
  style,
}: HeadingProps): ReactElement {
  return (
    <h6
      className={classNames(rootClass, className, {
        [responsiveClass]: responsive,
      })}
      style={style}
    >
      {children}
    </h6>
  );
}

export default H6;
